<template>
  <component
    :is="component"
    :class="rootClass"
    :style="rootStyle"
  />
</template>

<script>

import defaultRootComponent from '../defaultRootComponent'

export default {
  name: 'Skeleton',

  mixins: [ defaultRootComponent('div') ],

  props: {
    /*
     * This API is a little shaky in the sense that
     * these three booleans can't be made mutually
     * exclusive and an opinionated decision on prority
     * has to be made
     *
     * it makes for a bit of a cleaner syntax though :)
     */
    text: {
      type: Boolean
    },

    circle: {
      type: Boolean
    },

    rectangle: {
      type: Boolean
    },

    width: {
      type: String
    },

    height: {
      type: String
    }
  },

  computed: {
    rootClass () {
      return [
        this.$style.root,
        {
          [ this.$style.text ]: this.text,
          [ this.$style.circle ]: this.circle,
          [ this.$style.rectangle ]: this.rectangle,
        }
      ]
    },

    rootStyle () {
      return {
        width: this.width,
        height: this.height
      }
    }
  }
}

</script>

<style module>

@keyframes pulsate {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
}

.root {
  animation: pulsate 1.5s ease-in-out 0.5s infinite;
  @apply bg-gray-400;
}

.text {
  @apply rounded;
}

.text:empty::before {
  content: "\00a0";
}

.circle {
  @apply rounded-full;
}

.rectangle {
  width: 100%;
}

</style>
